const API_ENDPOINTS = {
  LOGIN: "/v1/auth/login",
  REGISTER: "/v1/auth/createNewAccount",
  REGISTER_SEND_OTP: "/v1/auth/register/send-otp",
  REGISTER_VERIFY_OTP: "/v1/auth/register/verify-otp",
  REGISTER_COMPLETE: "/v1/auth/register/complete",
  FORGOT_PASSWORD_SEND: "/v1/auth/forgot-password/send-otp",
  FORGOT_PASSWORD_RESET: "/v1/auth/forgot-password/reset",
  FORGOT_PASSWORD_VERIFY: "/v1/auth/forgot-password/verify",

  DOCUMENT: {
    UPLOAD: "/api/v1/documents/upload",
    BULK_UPLOAD: "/api/v1/documents/bulk-upload",
    HISTORY: "/v1/document/search",
    CHECK_PLAGIARISM: "/api/v1/enhanced_reports",
    REPORT_RESULT:"/v1/document/read",
    ANALYTICS:"/v1/document/analytics",
    HIGHLIGHT_REPORT_DOWNLOAD: (id: number) => `/api/v1/enhanced_reports/${id}/professional-report-with-highlights`,
    SUMMARY_REPORT_DOWNLOAD: "/api/v1/reports",
    DELETE: (id: number) => `/v1/document/delete/${id}`
  },

  DASHBOARD: {
    DATA: "/v1/dashboard",
    USAGE_ANALYTICS: "/v1/dashboard/usage-analytics"
  },

  USER: {
    CURRENT_USER: "/v1/user/me",
    CHANGE_PASSWORD: "/v1/user/change-password",
    LIST: "/v1/user/read"
  },

  ADMIN: {
    GET_ALL_USERS: "/v1/admin/users",
    CREATE_USER: "/v1/admin/create-user",
    UPDATE_USER: (id: number) => `/v1/admin/update-user/${id}`,
    DELETE_USER: (id: number) => `/v1/admin/delete-user/${id}`,
    GET_TICKETS: "/v1/admin/tickets",
    UPDATE_TICKET: (id: number) => `/v1/admin/update-ticket/${id}`,
    DELETE_TICKET: (id: number) => `/v1/admin/delete-ticket/${id}`,
    BILLING: {
      TRANSACTIONS: "/v1/admin/billing/transactions",
      TRANSACTION: (id: number) => `/v1/admin/billing/transactions/${id}`,
      INVOICE: (id: number) => `/v1/admin/billing/transactions/${id}/invoice`,
      USER: (userId: number) => `/v1/admin/billing/users/${userId}`,
      CREDIT_LEDGER: (userId: number) =>
        `/v1/admin/billing/users/${userId}/credit-ledger`,
      ADJUST_CREDITS: "/v1/admin/billing/credits/adjust",
      SUBSCRIPTION: (id: number) => `/v1/admin/billing/subscriptions/${id}`,
    },
  },

  API_KEY: {
    CREATE_API_KEY: "/v1/api-key/create-api-key",
    LIST_API_KEYS: "/v1/api-key/search",
    REGENERATE_API_KEY: (id: number) => `/v1/api-key/${id}/regenerate`,
    API_CALLS: "/v1/api-key/api-calls",
    DELETE_API_KEY: "/v1/api-key/delete",
    UPDATE: (id: number) => `/v1/api-key/update/${id}`
  },

  TEAM: {
    CREATE: "/v1/team/create",
    LIST: "/v1/team/search",
    DELETE: (id: number) => `/v1/team/delete/${id}`,
    UPDATE: (id: number) => `/v1/team/update/${id}`,
  },

  PAYMENT: {
    PRICING: "/v1/payment/pricing",
    CREATE_ORDER: "/v1/payment/create-order",
    VERIFY_PAYMENT: "/v1/payment/verify-payment",
    CANCEL_PAYMENT: "/v1/payment/cancel-payment",
    TRANSACTION_INVOICE: (transactionId: number) =>
      `/v1/payment/transactions/${transactionId}/invoice`,
    TRANSACTIONS: "/v1/payment/transactions",
    SUBSCRIPTION: "/v1/payment/subscription",
    CREDITS: "/v1/payment/credits",
    DEDUCT_CREDITS: "/v1/payment/deduct-credits"
  },
  
  CONTACT: {
    SUBMIT: "/v1/contact/submit",
    SEARCH: "/v1/contact/search",
  },
};
export default API_ENDPOINTS;
